import React, { Component } from 'react';
import DataAPI from '../../../Utils/Api';
import styled from "styled-components"
import Color from 'color';
import yellowStar from '../../../../assets/imgs/star_yellow.png';
//import greyStar from '../../../../assets/imgs/star_unfill.png';

import greyStar from '../../../../assets/imgs/greyStar.png';


function setTextColor(color){
    return Color(color).isLight() && Color(color).luminosity() > 0.4  ? "#000" : "#fff";
}

/**
 * 
 * #TODO: #1. Memoize the setColorText function for primaryColor
 * 
 * */

/**
 * Implementation of #1
 */
let inverseColor = '0';
function getInverseColorForPrimaryColor(primaryColor){
    if(inverseColor == '0')
        inverseColor = setTextColor(primaryColor);
    return inverseColor;    
}

const StyledFooter = styled.div`

    .sf-footer-wrapper{
        background : ${props => '#fafafa' || props.data.primaryColor};
        color:  ${props => '#333' || getInverseColorForPrimaryColor(props.data.primaryColor)};

        .sf-footer{
            .sf-yesno{
                color:  ${props => '#333' || getInverseColorForPrimaryColor(props.data.primaryColor)};
            }

            form#textfeedback {
                background : ${props => '#fafafa' || props.data.primaryColor};
                input {
                    color : ${props => '#333' || getInverseColorForPrimaryColor(props.data.primaryColor)};
                    &::-webkit-input-placeholder{
                        color : ${props => '#333' || getInverseColorForPrimaryColor(props.data.primaryColor)};
                    }
                }
                button {
                    color : ${props => '#333' || getInverseColorForPrimaryColor(props.data.primaryColor)};
                }
                #closeFeedback{
                    color : ${props =>'#333' || getInverseColorForPrimaryColor(props.data.primaryColor)};
                }
            } 
        }
    } 
`
interface IProps{
    data,
    showOverlayFeedback,
    selectedRating,
    isOverlayVisible,
    closeFlag,
    isFeedbackEnable
}

interface IState{
    isFeedbackFormVisible : boolean,
    isFormSubmited : boolean,
    exitFeedbackMessageChange: boolean,
    resubmitPopMessage: boolean
    star1 :any,
    star2 :any,
    star3 :any,
    star4 :any,
    star5 :any,
}

var tmRef ;
class Footer extends Component<IProps,IState> {
    private feedbackInput: React.RefObject<HTMLInputElement>;
    constructor(props) {
        super(props);
        this.feedbackInput = React.createRef();

        this.state = {
            isFeedbackFormVisible : false,
            exitFeedbackMessageChange: false,
            isFormSubmited : false,
            resubmitPopMessage: false,
            star1:greyStar,
            star2:greyStar,
            star3:greyStar,
            star4:greyStar,
            star5:greyStar,
            
        }




    }

    yesNoFeedback(yesNo: boolean) {
        this.setState({isFeedbackFormVisible : true});
        DataAPI().get('/star?rating='+yesNo)
        .then((response) => {
            //
        })
        .catch((error) => {
            console.log(error);
        })
    }

    sendFeedback(ev){
        ev.preventDefault();

        var feed = this.feedbackInput.current.value;
        this.setState({isFormSubmited : true , isFeedbackFormVisible  :true})
        DataAPI().get('/feedback?comment='+feed)
            .then((response) => {
                //
                //this.hideFeedbackForm();
            })
            .catch((error) => {
                console.log(error);
            })

        tmRef = setTimeout(() => {
            this.hideFeedbackForm();
            this.setState({isFormSubmited : false})
        },900)
    } 

    hideFeedbackForm(){
        this.setState({isFeedbackFormVisible : false});
    }

    openSenseforth(){
        window.open("http://www.senseforth.ai","_blank")
    }

   
    componentWillUnmount(){
        clearTimeout(tmRef); 
        
    }

    // componentWillReceiveProps(){

    //     if(this.props.isOverlayVisible){
    //         this.setState({

    //             star1:greyStar,
    //             star2:greyStar,
    //             star3:greyStar,
    //             star4:greyStar,
    //             star5:greyStar,

    //         })
    //     } 
    // }

    handleStarClick(rating){
       
        if(rating == 1){
           this.setState({
               star1:yellowStar,
               star2:greyStar,
               star3:greyStar,
               star4:greyStar,
               star5:greyStar,
           })
        }else if(rating == 2){
            this.setState({
                star1:yellowStar,
                star2:yellowStar,
                star3:greyStar,
                star4:greyStar,
                star5:greyStar,
            })
        }else if(rating == 3){
            this.setState({
                star1:yellowStar,
                star2:yellowStar,
                star3:yellowStar,
                star4:greyStar,
                star5:greyStar,
            })
        }else if(rating == 4){
            this.setState({
                star1:yellowStar,
                star2:yellowStar,
                star3:yellowStar,
                star4:yellowStar,
                star5:greyStar,
            })
        }else if(rating == 5){
            this.setState({
                star1:yellowStar,
                star2:yellowStar,
                star3:yellowStar,
                star4:yellowStar,
                star5:yellowStar,
            })
        }

         //{` ${this.props.closeFlag?"starAlignmentID":"starsWrapperID"}`}
        // document.getElementById("starsWrapperID").style.pointerEvents = "none";
       // console.log(document.querySelectorAll(".star-div"))

         document.querySelectorAll(".star-div").forEach(element =>{

           // console.log(element);
            element.classList.add('disabledStars');
         })

         this.setState({
            exitFeedbackMessageChange: true,
            resubmitPopMessage: true
         })

         


    }

    handleResubmit(){

        if(this.state.resubmitPopMessage){

   //        console.log("show me")
           document.querySelectorAll(".pop-wrapper").forEach(element => {

               element.classList.add("show-pop-wrapper");
            //    console.log(element)
               
           });

           setTimeout(() =>{
             
            document.querySelectorAll(".pop-wrapper").forEach(element => {
 
                element.classList.remove("show-pop-wrapper");
                // console.log(element)
                
            });

        },2000);

  
        }

        
    }


    componentDidUpdate(prevProps,prevState){
        if(prevProps.selectedRating !== this.props.selectedRating){
            this.handleStarClick(this.props.selectedRating);
        }
    }
    

    render() {
        return (
            // <React.Fragment>
            // {(this.props.isFeedbackEnable)?(
            <StyledFooter data={this.props.data} >
          
            <div className={`${this.props.closeFlag?"":"sf-footer-wrapper"}`} onClick={()=>{this.handleResubmit()}} >
                <div className={` ${this.props.closeFlag?"":"sf-footer"}`} id="sf-feedback-still" style={{transition:'transform 0.3s',transitionDelay:'1.5s',transform:!this.props.isFeedbackEnable?'translateY(33px)':'translateY(0px)'}}>
                    <div className={` ${this.props.closeFlag?"feedback-alignment":"sf-footer-left"}`}>
                    {this.props.closeFlag?
                    <div style={{padding: "10px"}}>
                        {this.state.exitFeedbackMessageChange?
                        <div>
                            Thank you for sharing your feedback.
                        </div>
                        :
                        <div>
                            Would you like to share your experience?
                        </div>}
                    </div>:
                    <span style={{fontWeight:500}}>Share Your Experience</span>}

                        <div className={` ${this.props.closeFlag?"star-alignment":"stars-wrapper"}`} id="starsWrapperID">
                            <div className="star-div" onClick={()=>{this.props.showOverlayFeedback(1);this.handleStarClick(1)}} ><img src={this.state.star1}></img></div>
                            <div className="star-div" onClick={()=>{this.props.showOverlayFeedback(2);this.handleStarClick(2)}}><img src={this.state.star2}></img></div>
                            <div className="star-div" onClick={()=>{this.props.showOverlayFeedback(3);this.handleStarClick(3)}}><img src={this.state.star3}></img></div>
                            <div className="star-div" onClick={()=>{this.props.showOverlayFeedback(4);this.handleStarClick(4)}}><img src={this.state.star4}></img></div>
                            <div className="star-div" onClick={()=>{this.props.showOverlayFeedback(5);this.handleStarClick(5)}}><img src={this.state.star5}></img></div>
                         
                        </div>


                        {!this.props.closeFlag?  
                        <div className="pop-wrapper">
                            <div>We have already received your feedback</div>   
                        </div>:null
                        }

                    </div>
                </div>
          
            </div>
            </StyledFooter>
            // <StyledFooter data={this.props.data}>
            // <div className="sf-footer-wrapper">
            //     <div className="sf-footer" id="sf-feedback-still">
            //         <div style={{display : this.state.isFeedbackFormVisible ? "none" : "flex",width:"100%"}}>
            //             <div className="sf-footer-left">
            //                 {/* <img style={{width:"16px",height:"16px",marginRight:"8px"}} src="https://hbchat.senseforth.com/HDFC_Chat/assets/feed-info.svg" /> */}
            //                 <span style={{ width: "16px", height: "16px", marginRight: "8px" }} className="sf-feed-info"></span>
            //                 <span>Was I helpful ?</span>

            //                 <div className="sf-yesno">
            //                     <b style={{cursor:"pointer",marginRight:'10px'}} onClick={this.yesNoFeedback.bind(this, 1)}>Yes</b>
            //                     <b style={{cursor:"pointer"}} onClick={this.yesNoFeedback.bind(this, 0)}>No</b>
            //                 </div>
            //             </div>
            //             {/* <div className="sf-footer-right">
            //                 <span style={{fontSize:"0.9em"}}>Powered by</span>
            //                 <b style={{cursor:"pointer"}}
            //                      onClick={this.openSenseforth.bind(this)}
            //                      //onMouseOver={(ev) => (ev.target as HTMLInputElement).style.fontSize = "1em"}
            //                      //onMouseOut={(ev) => (ev.target as HTMLInputElement).style.fontSize = "0.9em"}
            //                 >
            //                     senseforth.ai
            //                 </b>
            //             </div> */}
            //         </div>
            //         <div style={{display : this.state.isFeedbackFormVisible ? "flex" : "none",width:"100%",alignItems:"center"}}>
            //             {!this.state.isFormSubmited  ?
            //                 <React.Fragment>
            //                     <form name="form" id="textfeedback" className="sf-bottom-bar">
            //                     <span style={{ width: "16px", height: "16px", marginRight: "8px" }} className="sf-feed-info"></span>

            //                             <input ref={this.feedbackInput}
            //                                 placeholder="Type your comments here" type="input" 
            //                                 autoComplete="off"
            //                                 name="textfeedback" />
            //                         <button type="submit" onClick={this.sendFeedback.bind(this)}>Send</button>
            //                         <button id="closeFeedback" onClick={this.hideFeedbackForm.bind(this)} type="button"> Cancel</button>
            //                     </form>
            //                 </React.Fragment>
            //                 :
            //                 <React.Fragment>
            //                     <span style={{ width: "16px", height: "16px", marginRight: "16px",marginLeft:"5px" }} className="sf-feed-thanks"></span>
            //                     <span>Thank you for submiting your feedback</span>
            //                 </React.Fragment>
            //             }
            //         </div>
            //     </div>
            // </div>
            // </StyledFooter>
            // ):null} 
            // </React.Fragment>
        );
    }
}

export default Footer;
